import { render, staticRenderFns } from "./BaseNavigation.vue?vue&type=template&id=3a31b9f8&"
import script from "./BaseNavigation.vue?vue&type=script&lang=js&"
export * from "./BaseNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports